/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ODataServiceDocument } from '../../models/o-data-service-document';

export interface Odata$JsonOdataMetadataFullOdataStreamingTrue$Params {
}

export function odata$JsonOdataMetadataFullOdataStreamingTrue(http: HttpClient, rootUrl: string, params?: Odata$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ODataServiceDocument>> {
  const rb = new RequestBuilder(rootUrl, odata$JsonOdataMetadataFullOdataStreamingTrue.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=full;odata.streaming=true', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ODataServiceDocument>;
    })
  );
}

odata$JsonOdataMetadataFullOdataStreamingTrue.PATH = '/odata';
